import { useStore } from 'react-redux';
import { BaseApiErrorResponse, BaseApiResponse } from 'services/api/api-config';
import {
  invalidateLoadedResourceIfPresent,
  requestDataIfNecessary,
} from 'services/api/api.actions';
import {
  useSelectApiResourceLoadState,
  useSelectApiResourceResponse,
} from 'services/api/api.hooks';
import { RequestApiDataIfNecessaryPayload } from 'services/api/api.types';
import { ReduxSelector } from 'store/types';
import { useOnce } from '../use-once';

export function useQuery<
  TData = BaseApiResponse,
  TError = BaseApiErrorResponse,
>(
  resourceId: string,
  opts: {
    apiConfig: ReduxSelector<RequestApiDataIfNecessaryPayload>;
    isActive?: boolean;
  },
) {
  /*------------------------------hooks------------------------------*/
  const reduxStore = useStore();
  const loadingState = useSelectApiResourceLoadState(resourceId);
  const queryData = useSelectApiResourceResponse<TData, TError>(resourceId);

  /*------------------------------helpers------------------------------*/
  const makeQuery = async () => {
    reduxStore.dispatch(
      requestDataIfNecessary(opts.apiConfig(reduxStore.getState())),
    );
  };

  const invalidateQuery = () => {
    reduxStore.dispatch(
      invalidateLoadedResourceIfPresent({
        resourceId,
      }),
    );
    makeQuery();
  };

  /*------------------------------effects------------------------------*/
  useOnce(() => {
    if (opts?.isActive !== false) makeQuery();
  });

  return {
    ...loadingState,
    ...queryData,
    refetch: makeQuery,
    invalidate: invalidateQuery,
  };
}
